import { ApplicationElement, html } from '../application_element/element.js';
import style from './style.lit.css';

import '../icon/element.js';

/**
 * Simple item with icon and text
 *
 * @prop theme - Item color (options: primary, secondary, success, info, warning, danger, light)
 */
export default class IconBlock extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    icon: { type: String },
    text: { type: String },
    theme: { type: String, reflect: true },
    layout: { type: String, reflect: true },
  };

  updated(changedProperties) {
    if (changedProperties.has('text')) {
      this.innerHTML = this.text;
    }
  }

  render() {
    return html`
      <ef-icon name=${this.icon}></ef-icon>
      <span><slot>${this.text}</slot></span>
    `;
  }
}

customElements.get('ef-icon-block') ||
  customElements.define('ef-icon-block', IconBlock);
